module.exports = __webpack_public_path__ + "assets/img/discount.843cfb4f.svg";